import React from 'react';
import { Box } from '@mui/material';

// iOS Safari's 100vh includes the area behind its toolbar, so a button pushed to the
// bottom of a 100vh column ends up off screen. 100dvh is the visible height.
export const fullScreenHeight = {
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
};

/**
 * Keeps the page's main action visible at the bottom of the screen on every iPhone size,
 * clear of the home indicator (needs viewport-fit=cover in index.html for env()).
 */
export default function StickyActionBar({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        mx: -2,
        px: 2,
        pt: 1.5,
        pb: 'calc(12px + env(safe-area-inset-bottom))',
        // boxShadow: '0 -8px 16px -8px rgba(0,0,0,0.08)',
      }}
    >
      {children}
    </Box>
  );
}
